let TrackPlays = {
    init: function () {
        this.bind();
    },

    bind: function () {
        this.reports();
    },

    reports: function () {
        let reportsForm = $('#reportsForm');
        let submitBtn = Ladda.create(reportsForm.find('[type=submit]')[0]);

        reportsForm.ajaxForm({
            beforeSubmit: function () {
                submitBtn.start();
            },

            success: function (response) {
                if (response.success) {
                    $('#reportsTableContainer').html(response.content);
                    DataTables.reports(response.type, response.group);
                } else {
                    toastr.error(response.error.message);
                }
                submitBtn.stop();
            },

            error: function (response) {
                toastr.error(response.responseJSON.error.message);
                submitBtn.stop();
            }
        });

        let filtersContainer = $('#trackPlaysFilters');
        filtersContainer.find('[name="report_type"]').on('change', function () {
            let reportType = $(this).val();

            if(reportType === 'users') {
                filtersContainer.find('.filter').removeClass('hide');
                filtersContainer.find('.filter.group').addClass('hide');
            } else if (reportType === 'group-by') {
                filtersContainer.find('.filter').addClass('hide');
                filtersContainer.find('.filter.group').removeClass('hide');
            } else {
                filtersContainer.find('.filter').removeClass('hide');
                filtersContainer.find('.filter.group').addClass('hide');
                filtersContainer.find('.filter.user').addClass('hide');
            }
        });
    }
};


$().ready(function () {
    window.TrackPlays = TrackPlays;
    window.TrackPlays.init();
});
